import { withStyles } from '@material-ui/core/styles';
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';
import React, { useReducer, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AddNewPopUPModel from '../../../../../shared/add-new-popup/Add-New-Popup-Model';
import CustomCheckbox from '../../../../../shared/form-controls/custom-checkbox/Custom-Checkbox';
import CustomSelect from '../../../../../shared/form-controls/custom-select/Custom-Select';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import KeyValuePairList from '../../../../../shared/key-value-pair-list/KeyValuePairList';
import { formDataValidate } from '../../../../../utils/formUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import { addInRoomDiningAllergen, addInRoomDiningTag } from '../../../../../utils/ServicesAPIUtils';
import {
  fetchAllInRoomDining,
  inRoomDiningAllergensSelector,
  inRoomDiningKindsSelector,
  inRoomDiningTagsSelector,
} from '../../../servicesSlice';
import CustomChipInput from './../../../../../shared/form-controls/custom-chip-input/Custom-Chip-Input';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const CustomToolTip = withStyles({
  tooltip: {
    color: 'white',
    backgroundColor: 'black',
  },
})(Tooltip);

const ItemCreateDetails = (props) => {
  const { formData, setFormData, hotelId, restaurantId, showLoader = () => {} } = props;
  const originalTags = useSelector(inRoomDiningTagsSelector);
  const originalAllergens = useSelector(inRoomDiningAllergensSelector);
  const originalKinds = useSelector(inRoomDiningKindsSelector);
  const [addNewValues, setAddNewValues] = useState({
    title: '',
    status: false,
  });
  const dispatch = useDispatch();

  const [tagFormData, setTagFormData] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      name: {
        value: '',
        fieldName: 'Tag Name',
        errors: {},
        validations: ['required'],
      },
      code: {
        value: '',
        fieldName: 'Tag Code',
        errors: {},
        validations: ['required', 'validAlphaNumeric'],
      },
    },
  );

  const [allergenFormData, setAllergenFormData] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      name: {
        value: '',
        fieldName: 'Allergen Name',
        errors: {},
        validations: ['required'],
      },
      code: {
        value: '',
        fieldName: 'Allergen Code',
        errors: {},
        validations: ['required', 'validAlphaNumeric'],
      },
    },
  );

  const onOpenModel = (selectedValue, textFieldValue) => {
    setAddNewValues({
      title: selectedValue,
      status: true,
    });
    const nameFieldTagsFormData = { ...tagFormData.name };
    nameFieldTagsFormData.value = textFieldValue;
    setTagFormData({ name: nameFieldTagsFormData });
    const nameFieldAllergensFormData = { ...allergenFormData.name };
    nameFieldAllergensFormData.value = textFieldValue;
    setAllergenFormData({ name: nameFieldAllergensFormData });
  };

  const validateFormData = (selectedFormData, setSelectedFormData) => {
    const updatedFields = {};
    const isValid = formDataValidate(selectedFormData, updatedFields);
    setSelectedFormData(updatedFields);
    return isValid;
  };

  const renderModelForm = (selectedFormData, setSelectedFormData) => {
    return (
      <div>
        <div className='mx-4'>
          <div className='col-md-12 mb-3'>
            <CustomTextField
              item={selectedFormData.name}
              handleInputChange={(e) => {
                setSelectedFormData({ name: e });
              }}
              maxLength={60}
              endAdornment={true}
              characterCount={true}
            />
          </div>
          <div className='col-md-12 mb-3'>
            <CustomTextField
              item={selectedFormData.code}
              handleInputChange={(e) => {
                setSelectedFormData({ code: e });
              }}
              maxLength={8}
            />
          </div>
        </div>
      </div>
    );
  };

  const activeAllergens = originalAllergens?.filter((allergen) => allergen?.status);

  const activeTags = originalTags?.filter((tag) => tag?.status);

  const onClickAddValues = async (selectedValue, selectedFormData, setSelectedFormData) => {
    if (hotelId && validateFormData(selectedFormData, setSelectedFormData)) {
      try {
        dispatch(stepUpLoaderCount());
        const payload = {
          name: selectedFormData?.name?.value,
          code: selectedFormData?.code?.value,
          hotelId: hotelId,
          restaurantId: restaurantId,
          status: addNewValues?.status,
        };
        if (selectedValue === 'Tags') {
          const resp = await addInRoomDiningTag(payload);
          const tagsIdFormData = formData?.tags;
          const updatedTagsId = [...tagsIdFormData.value, resp.data.createIRDTag.id];
          tagsIdFormData.value = [...updatedTagsId];
          setFormData({ tags: tagsIdFormData });
          notificationManager('success', 'Tag created successfully');
        } else {
          const resp = await addInRoomDiningAllergen(payload);
          const allergensIdFormData = formData?.allergens;
          const updatedAllergensId = [
            ...allergensIdFormData?.value,
            resp.data.createIRDAllergen?.id,
          ];
          allergensIdFormData.value = [...updatedAllergensId];
          setFormData({ allergens: allergensIdFormData });
          notificationManager('success', 'Allergen created successfully');
        }
        selectedFormData.name.value = '';
        selectedFormData.code.value = '';
        dispatch(fetchAllInRoomDining(hotelId, restaurantId));
        handlePopupClose();
      } catch (error) {
        if (error.graphQLErrors) {
          notificationManager('danger', error?.graphQLErrors?.[0]?.message);
        } else {
          selectedValue === 'Tags'
            ? notificationManager('danger', 'Tag creation failed')
            : notificationManager('danger', 'Allergen creation failed');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
    }
  };

  const handlePopupClose = () => {
    setAddNewValues({
      title: '',
      status: false,
    });
    const resetTagsFormData = { ...tagFormData };
    resetTagsFormData.name.value = '';
    resetTagsFormData.code.value = '';
    setTagFormData(resetTagsFormData);
    const resetAllergenFormData = { ...allergenFormData };
    resetAllergenFormData.name.value = '';
    resetAllergenFormData.code.value = '';
    setAllergenFormData(resetAllergenFormData);
  };

  return (
    <div className='row px-3 w-100 d-flex mt-4'>
      {addNewValues && addNewValues.status === true && addNewValues.title === 'Tag' && (
        <AddNewPopUPModel
          addNewPopUp={addNewValues}
          addNewField='Tags'
          addNewFormData={tagFormData}
          setAddNewFormData={setTagFormData}
          onClickAdd={onClickAddValues}
          onClickCancel={handlePopupClose}
          renderModel={renderModelForm}
          formData={tagFormData}
        />
      )}
      {addNewValues && addNewValues.status === true && addNewValues.title === 'Allergen' && (
        <AddNewPopUPModel
          addNewPopUp={addNewValues}
          addNewField='Allergens'
          addNewFormData={allergenFormData}
          setAddNewFormData={setAllergenFormData}
          onClickAdd={onClickAddValues}
          onClickCancel={handlePopupClose}
          renderModel={renderModelForm}
          formData={allergenFormData}
        />
      )}
      <h4 className='tab-title'>Details</h4>
      <div className='row px-3 w-100 align-items-center'>
        <div className='col-md-6 mb-0'>
          <CustomSelect
            item={formData.type}
            handleInputChange={(e) => {
              setFormData({ type: e });
            }}
            labelField='name'
            valueField='id'
            options={originalKinds}
            hideNullOption={originalKinds.length}
          />
        </div>

        <div className='col-auto d-inline-flex align-items-center mb-0'>
          <CustomCheckbox
            item={formData.status}
            handleInputChange={(e) => setFormData({ status: e })}
            color='primary'
          />
          <CustomToolTip title='Deactivating this, hides it from Guest app' placement='right-end'>
            <InfoIcon fontSize='small' className='ms-2 align-middle' />
          </CustomToolTip>
        </div>
      </div>
      <div className='row'>
        <div className='col-md-6 mb-3'>
          <CustomTextField
            item={formData.name}
            handleInputChange={(e) => {
              setFormData({ name: e });
            }}
            maxLength={150}
            endAdornment={true}
            characterCount={true}
            multiline={true}
          />
        </div>
        <div className='col-md-6 mb-3'>
          <CustomTextField
            item={formData.code}
            handleInputChange={(e) => {
              setFormData({ code: e });
            }}
            maxLength={1000}
            multiline={true}
            endAdornment={true}
            characterCount={true}
          />
        </div>
      </div>
      <div className='row'>
        <div className='col-md-12 mb-3'>
          <CustomTextField
            item={formData.description}
            handleInputChange={(e) => {
              setFormData({ description: e });
            }}
            multiline={true}
          />
        </div>
      </div>
      <div className='row'>
        <div className='col-md-6 mb-3'>
          <CustomTextField
            item={formData.price}
            handleInputChange={(e) => {
              setFormData({ price: e });
            }}
            type='number'
            min={0}
            max={99999999}
            allowZero
          />
        </div>
      </div>
      <div className='row'>
        <div className='col-md-12 mb-3'>
          <CustomTextField
            item={formData.ingredients}
            handleInputChange={(e) => {
              setFormData({ ingredients: e });
            }}
            maxLength={350}
            endAdornment={true}
            characterCount={true}
            multiline={true}
          />
        </div>
      </div>
      <div className='row mb-3'>
        <CustomChipInput
          options={activeAllergens}
          labelField='name'
          textFieldLabel='Allergens'
          textFieldPlaceholder='Select Allergens'
          isAddNewEnabled={true}
          addNewField='Allergen'
          onClickAddNew={onOpenModel}
          formData={formData}
          setFormData={setFormData}
          formField='allergens'
        />
      </div>
      <div className='row mb-4'>
        <CustomChipInput
          options={activeTags}
          labelField='name'
          textFieldLabel='Tags'
          textFieldPlaceholder='Select Tags'
          isAddNewEnabled={true}
          addNewField='Tag'
          onClickAddNew={onOpenModel}
          formData={formData}
          setFormData={setFormData}
          formField='tags'
        />
      </div>
      <KeyValuePairList
        item={formData.customAttributes}
        onListChange={(e) => {
          setFormData({ customAttributes: e });
        }}
      />
    </div>
  );
};

export default ItemCreateDetails;
